import { render, staticRenderFns } from "./ApplicationFooter.vue?vue&type=template&id=42d22942&scoped=true&"
import script from "./ApplicationFooter.vue?vue&type=script&lang=ts&"
export * from "./ApplicationFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationFooter.vue?vue&type=style&index=0&id=42d22942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d22942",
  null
  
)

export default component.exports